import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { GraphConfig } from "@intelligems/ig-types";
import { useTheme } from "@mui/material";
import { AxisTick } from "@src/features/analytics/baseDashboard/chartComponents/AxisTick";
import { useGraphValueFormatter } from "@src/features/analytics/hooks/use-graph-value-formatter";
import { IgHistogramTooltip } from "@src/features/analytics/tooltips/IgHistogramTooltip";
import { useSelector } from "@src/store";
import { selectedVariations } from "@src/store/slices/variations";
import { HistogramMetricData } from "@src/types/analytics";

interface IgHistogramChartProps {
  groupMetricData: HistogramMetricData[];
  config: GraphConfig;
  selectedVariationId?: string;
  graphHeight?: number;
}

export const IgHistogramChart = ({
  config,
  groupMetricData,
  selectedVariationId,
  graphHeight,
}: IgHistogramChartProps) => {
  const variations = useSelector(selectedVariations);
  const theme = useTheme();
  const graphValueFormatter = useGraphValueFormatter();
  return (
    <ResponsiveContainer height={graphHeight ?? 300} width="100%">
      <BarChart
        style={{ marginLeft: -24 }}
        margin={{ top: 5, bottom: 5 }}
        data={groupMetricData}
      >
        <CartesianGrid
          style={{ stroke: theme.igBorders.core.disabled }}
          vertical={false}
        />
        <XAxis
          interval={"preserveEnd"}
          tick={(props: any) => {
            return (
              // @ts-ignore
              <AxisTick
                config={config}
                graphValueFormatter={graphValueFormatter}
                groupMetricData={groupMetricData}
                {...props}
              />
            );
          }}
          axisLine={{ stroke: theme.igBorders.core.disabled }}
          tickLine={false}
          dataKey={(ev) => `${ev.bucket}`}
        />
        <YAxis
          allowDecimals={false}
          type={"number"}
          style={{ fontFamily: theme.typography.fontFamily, fontSize: 10 }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(value: any) =>
            graphValueFormatter({
              isAxisTick: true,
              value,
              configDataTypes: ["numberNoDecimal"],
            })!
          }
        />
        <Tooltip content={<IgHistogramTooltip config={config} />} />
        <Bar
          radius={[3, 3, 0, 0]}
          dataKey={`${selectedVariationId}`}
          fill={theme.igBackgroundColors.accentSolid}
          stackId="a"
        />
      </BarChart>
    </ResponsiveContainer>
  );
};
